import { Global } from '@mantine/core';
import {
  GothamLight,
  GothamMedium,
  GothamThin,
  GothamBold,
  GothamSemiMedium,
  GothamSemiBold,
  MontserratBold,
  MontserratExtraBold,
  MontserratLight,
  MontserratMedium,
  MontserratRegular,
  MontserratSemiBold,
} from './fonts';
export function CustomFonts() {
  return (
    <Global
      styles={[
        {
          '@font-face': {
            fontFamily: 'Gotham',
            src: `url('${GothamThin}') format("truetype")`,
            fontWeight: 300,
            fontStyle: 'Thin',
          },
        },
        {
          '@font-face': {
            fontFamily: 'Gotham',
            src: `url('${GothamLight}') format("truetype")`,
            fontWeight: 400,
            fontStyle: 'Light',
          },
        },
        {
          '@font-face': {
            fontFamily: 'Gotham',
            src: `url('${GothamSemiMedium}') format("truetype")`,
            fontWeight: 450,
            fontStyle: 'Semi Medium',
          },
        },
        {
          '@font-face': {
            fontFamily: 'Gotham',
            src: `url('${GothamMedium}') format("truetype")`,
            fontWeight: 500,
            fontStyle: 'Medium',
          },
        },
        {
          '@font-face': {
            fontFamily: 'Gotham',
            src: `url('${GothamBold}') format("truetype")`,
            fontWeight: 700,
            fontStyle: 'Bold',
          },
        },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratLight}') format("truetype")`,
        //     fontWeight: 300,
        //     fontStyle: 'Light',
        //   },
        // },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratRegular}') format("truetype")`,
        //     fontWeight: 400,
        //     fontStyle: 'Regular',
        //   },
        // },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratMedium}') format("truetype")`,
        //     fontWeight: 500,
        //     fontStyle: 'Medium',
        //   },
        // },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratSemiBold}') format("truetype")`,
        //     fontWeight: 600,
        //     fontStyle: 'Semi Bold',
        //   },
        // },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratBold}') format("truetype")`,
        //     fontWeight: 700,
        //     fontStyle: 'Bold',
        //   },
        // },
        // {
        //   '@font-face': {
        //     fontFamily: 'Montserrat',
        //     src: `url('${MontserratExtraBold}') format("truetype")`,
        //     fontWeight: 800,
        //     fontStyle: 'Extra Bold ',
        //   },
        // },
      ]}
    />
  );
}
